export default {
  GET_BRIGADE_WORKS: state => state.brigade_works,
  GET_ALL_BRIGADE_WORKS: state => state.all_brigade_works,



  GET_BRIGADE_WORK_CATEGORIES: state => state.brigade_work_categories,
  GET_ALL_BRIGADE_WORK_CATEGORIES: state => state.all_brigade_work_categories,
  
  
  getProductList: state => state.productsList,
}
